import React, { useState } from 'react';
import { testimonials, gallery } from '../mock';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const Testimonials = () => {
  const [idx, setIdx] = useState(0);

  const next = () => setIdx((idx + 1) % testimonials.length);
  const prev = () => setIdx((idx - 1 + testimonials.length) % testimonials.length);

  return (
    <section id="stories" className="py-24 bg-[#1a2b17] relative overflow-hidden">
      <div className="absolute top-10 right-10 opacity-10">
        <Quote className="w-40 h-40 text-white" />
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div className="text-center mb-16">
          <div className="text-sm tracking-[0.2em] uppercase text-[#c9743a] mb-3">Real stories</div>
          <h2 className="font-serif text-4xl lg:text-5xl text-white tracking-tight">
            Hear from our happy clients
          </h2>
        </div>

        <div className="max-w-4xl mx-auto relative">
          <div className="bg-white rounded-3xl p-10 lg:p-14 shadow-2xl">
            <div className="flex items-center gap-1 mb-6">
              {[...Array(testimonials[idx].rating)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-[#e8a94b] text-[#e8a94b]" />
              ))}
            </div>
            <p className="font-serif text-2xl lg:text-3xl text-[#1a2b17] leading-relaxed italic">
              &ldquo;{testimonials[idx].text}&rdquo;
            </p>
            <div className="mt-8 flex items-center gap-4">
              <img
                src={testimonials[idx].image}
                alt={testimonials[idx].name}
                className="w-14 h-14 rounded-full object-cover"
              />
              <div>
                <div className="font-medium text-[#1a2b17]">{testimonials[idx].name}</div>
                <div className="text-xs text-[#7a8471]">Verified client · Google review</div>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center mt-8">
            <div className="flex gap-2">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIdx(i)}
                  className={`h-1.5 rounded-full transition-all ${
                    i === idx ? 'w-8 bg-[#c9743a]' : 'w-3 bg-white/30'
                  }`}
                />
              ))}
            </div>
            <div className="flex gap-3">
              <button
                onClick={prev}
                className="w-11 h-11 rounded-full bg-white/10 border border-white/20 text-white hover:bg-white hover:text-[#1a2b17] transition flex items-center justify-center"
              >
                <ChevronLeft className="w-4 h-4" />
              </button>
              <button
                onClick={next}
                className="w-11 h-11 rounded-full bg-white/10 border border-white/20 text-white hover:bg-white hover:text-[#1a2b17] transition flex items-center justify-center"
              >
                <ChevronRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>

        {/* Gallery */}
        <div className="mt-24">
          <div className="text-center mb-10">
            <div className="text-sm tracking-[0.2em] uppercase text-[#c9743a] mb-3">Transformations</div>
            <h3 className="font-serif text-3xl lg:text-4xl text-white">
              Results speak better than words
            </h3>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {gallery.map((src, i) => (
              <div
                key={i}
                className={`rounded-2xl overflow-hidden ${i % 3 === 1 ? 'md:translate-y-6' : ''}`}
              >
                <img
                  src={src}
                  alt={`transformation ${i + 1}`}
                  className="w-full h-56 object-cover hover:scale-110 transition-transform duration-700"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
